import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ASSET_VIEW_MANAGER_NAME = 'AssetViewManager';
export const ASSET_VIEW_MANAGER_SLOTS: Array<keyof AssetViewManagerClasses> = [
	'root',
] as const;

export type AssetViewManagerSlot = (typeof ASSET_VIEW_MANAGER_SLOTS)[number];

export interface AssetViewManagerClasses {
	root: string;
}

export type AssetViewManagerClassKey = keyof AssetViewManagerClasses;

export const getAssetViewManagerUtilityClass = (slot: string) =>
	generateUtilityClass(ASSET_VIEW_MANAGER_NAME, slot as AssetViewManagerSlot);

export const assetViewManagerClasses: AssetViewManagerClasses =
	generateUtilityClasses(ASSET_VIEW_MANAGER_NAME, ['root']);

export default assetViewManagerClasses;
